import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./i18n";

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("epn_lang") || "fr");

  useEffect(() => {
    localStorage.setItem("epn_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (path) => {
    const parts = path.split(".");
    let node = translations[lang];
    for (const p of parts) {
      if (node && typeof node === "object" && p in node) node = node[p];
      else return path;
    }
    return node;
  };

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be inside LanguageProvider");
  return ctx;
}
